
const WorkflowStepNotesPopupValidation = async (formState) => {
  let errors = {};

  if (formState.stepNotes.trim() === '') {
    errors.stepNotes = "Notes is required";
  } else if (formState.stepNotes.length > 8000) {
    errors.stepNotes = "Notes cannot be more than 8000 characters long";
  }

  return errors ? errors : {};
};

export default WorkflowStepNotesPopupValidation;